import React from 'react';
import {
  makeStyles,
  createStyles,
  Theme,
} from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import AvailableFeatureItem from '../reliht-features-item/available-feature-Item';
import ComingFeatureGreenItem from '../reliht-features-item/coming-feature-green-item';
import ComingFeaturePrimaryItem from '../reliht-features-item/coming-feature-primary-item';
import { baseTheme } from '../../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      marginTop: theme.spacing(2),
      backgroundColor: theme.palette.background.paper,
    },
  }),
);

export default function RelihtFeaturesList(props: any) : JSX.Element {
  const classes = useStyles(baseTheme);
  return (
    <Grid container spacing={2} className={classes.root}>
      <AvailableFeatureItem
        featureText="Follow your favorite leaders + view their content on web or mobile app feed" />
      <AvailableFeatureItem
        featureText="Copy leader notes + add your own affirmations on web or mobile app" />
      <AvailableFeatureItem
        featureText="Copy notes to your personal Library on web or mobile app" />
      <AvailableFeatureItem
        featureText="Create, organize, and store your notes on the web app" />
      <AvailableFeatureItem
        featureText="Journal (private) notes on web app + view them on mobile app" />
      <AvailableFeatureItem
        featureText="Create (closed + public group) notes on web app, go live to mobile app feed" />
      <AvailableFeatureItem
        featureText="Add highlight thumbnail pics on web app that pair with notes on mobile app feed" />
      <AvailableFeatureItem
        featureText="Share notes to social media or via email on web or mobile app" />
      <ComingFeatureGreenItem
        featureText="MONETIZE YOUR CONTENT THROUGH FEE-BASED GROUPS"
        releaseYear="2026"
      />
      <ComingFeaturePrimaryItem
        featureText="Leader ads in mobile app feed"
        releaseText="Future Development"
      />
      <ComingFeaturePrimaryItem
        featureText="Create notes and groups on the mobile app (in-app purchase)"
        releaseText="Future Development"
        last={true}
      />
    </Grid>
  );
}
